module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-roll/382/assets/fonts/6ebd8f1b9b5b41876ab1be2a1ee5a84d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/styles/fonts/icomoon.svg?qmfery
// module id = 1280
// module chunks = 3